import type { InputHTMLAttributes } from 'react';

export enum LiliRadioInputSize {
  SMALL = 'sm',
  MEDIUM = 'md',
  LARGE = 'lg',
}

export enum LiliRadioInputVariant {
  DOT = 'dot',
  CHECKMARK = 'checkmark',
}

interface LiliRadioInputBaseProps extends Omit<
  InputHTMLAttributes<HTMLInputElement>,
  'type' | 'size'
> {
  checked?: boolean;
  disabled?: boolean;
  size?: LiliRadioInputSize;
  variant?: LiliRadioInputVariant;
  /**
   * Hover class applied to the unchecked indicator. Defaults to the brand-primary text hover;
   * pass a different token (e.g. bw-06) to match a variant's hover treatment.
   */
  uncheckedHoverClassName?: string;
  /**
   * Stop the click from bubbling past the indicator. Opt-in because some consumers (e.g. a
   * clickable row wrapping the radio) rely on the bubble to handle selection.
   */
  stopClickPropagation?: boolean;
}

export type LiliRadioInputProps = LiliRadioInputBaseProps &
  (
    | {
        label: string;
        id: string;
      }
    | {
        label?: never;
        id?: string;
      }
  );
